export default __webpack_public_path__ + "static/media/hero-thumb-1cb.eac2d575.png";